import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import PatientDetail from '../components/PatientDetail';
import { Loader2 } from 'lucide-react';

const PatientDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [patient, setPatient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPatient = async () => {
      setLoading(true);
      setError(null);
      try {
        const { data, error: dbError } = await supabase
          .from('patients')
          .select('*')
          .eq('id', id)
          .single();

        if (dbError) throw dbError;
        setPatient(data);
      } catch (err) {
        console.error("Error loading patient detail page:", err);
        setError(err.message || "No se pudo cargar la información del paciente.");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchPatient();
    }
  }, [id]);

  const handleClose = () => {
    navigate('/patients');
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', flex: 1, height: '80vh', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '1rem', color: 'white' }}>
        <Loader2 className="animate-spin" size={36} style={{ color: '#00e5ff' }} />
        <span>Cargando ficha del paciente...</span>
      </div>
    );
  }

  if (error || !patient) {
    return (
      <div style={{ display: 'flex', flex: 1, height: '80vh', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '1.5rem', color: 'white' }}>
        <div style={{ fontSize: '1.2rem', color: '#ff5252', fontWeight: 'bold' }}>Error: {error || 'Paciente no encontrado'}</div>
        <button onClick={handleClose} style={{ background: 'rgba(255,255,255,0.05)', color: 'white', border: '1px solid rgba(255,255,255,0.1)', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' }}>
          VOLVER AL LISTADO
        </button>
      </div>
    );
  }

  return (
    <div className="patient-detail-page-container" style={{ padding: '0 1rem' }}>
      <PatientDetail patient={patient} onClose={handleClose} />
    </div>
  );
};

export default PatientDetailPage;
